module.exports = __webpack_public_path__ + "static/media/whiteClock.9338ea26.png";